import {  Radio,  RadioProps } from "@mui/material";
import React from "react";

export default function HolzfinderRadio(props: RadioProps) {
  return (
    <Radio
      sx={{
        color: "#D0C2A8",
      }}
      {...props}
    />
  );
}
